// src/components/ui/FullScreenLoader.jsx
import React from 'react';

const FullScreenLoader = ({ message = "Submitting your application..." }) => {
  return (
    <div className="fixed inset-0 bg-black/15 flex items-center justify-center z-50">
      <div className="text-center">
        <div className="relative">
          {/* Spinner */}
          <div className="w-24 h-24 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
          
          {/* Animated circles */}
          <div className="absolute top-0 left-0 w-24 h-24">
            <div className="absolute top-0 left-0 w-full h-full">
              <div className="w-3 h-3 bg-white rounded-full absolute -top-1 left-1/2 transform -translate-x-1/2 animate-pulse"></div>
            </div>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-white mb-2">Please Wait</h2>
        <p className="text-white text-opacity-90 mb-4">{message}</p>
        
        {/* Progress bar */}
        <div className="w-64 h-2 bg-white bg-opacity-30 rounded-full overflow-hidden">
          <div className="h-full bg-white rounded-full animate-progress"></div>
        </div>
        
        <style jsx>{`
          @keyframes progress {
            0% { width: 0%; }
            50% { width: 70%; }
            100% { width: 100%; }
          }
          .animate-progress {
            animation: progress 2s ease-in-out infinite;
          }
        `}</style>
      </div>
    </div>
  );
};

export default FullScreenLoader;